import React, { useRef, useState, useCallback, useEffect } from "react";
import classnames from "classnames";
import { connect } from "react-redux";
import { openModal } from "redux/actions/global";
import "./denounce-image-gallery-modal.scss";
import { t } from "utils";
import { ARTICLE_VARIANTS_REPORT_DRAWER } from "components/Modal";

function DenounceImageGalleryModal(props) {
  const { images, fallbackImage, openModal, articleId } = props;
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [photoDenounced, setPhotoDenounced] = useState(new Set());
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);
  const galleryRef = useRef(null);
  const scrollAnimationFrame = useRef(null);

  // Controlar si las flechas deben mostrarse
  useEffect(() => {
    const galleryElement = galleryRef.current;
    if (galleryElement) {
      const { scrollLeft, scrollWidth, clientWidth } = galleryElement;
      setShowLeftArrow(scrollLeft > 0); // Mostrar flecha izquierda si hay desplazamiento
      setShowRightArrow(scrollLeft < scrollWidth - clientWidth); // Mostrar flecha derecha si no se llegó al final
    }
  }, [currentImageIndex, images]);

  const openVariantsReportModal = useCallback(
    (photoDenounced) => {
      openModal({
        modalType: "drawerR",
        type: ARTICLE_VARIANTS_REPORT_DRAWER,
        articlesIds: [articleId],
        photoDenounced :photoDenounced,
        isMultiple: true,
        isFamily: false,
        step:"images"
      });
    },
    [photoDenounced, openModal]
  );

  const startScrolling = (direction) => {
    const scrollStep = () => {
      if (galleryRef.current) {
        galleryRef.current.scrollBy({ left: direction === "left" ? -40 : 40, behavior: "auto" });
        scrollAnimationFrame.current = requestAnimationFrame(scrollStep);
      }
    };
    scrollStep();
  };

  const stopScrolling = () => {
    if (scrollAnimationFrame.current) {
      cancelAnimationFrame(scrollAnimationFrame.current);
      scrollAnimationFrame.current = null;
    }
  };

  const handleCheckboxChange = (index) => {
    setPhotoDenounced((prevSelected) => {
      const newSelected = new Set(prevSelected);
      const imageAlt = images[index].alt; // Obtener el alt de la imagen

      if (newSelected.has(imageAlt)) {
        newSelected.delete(imageAlt); // Si ya está, eliminarlo
      } else {
        newSelected.add(imageAlt); // Si no está, agregarlo
      }

      return newSelected;
    });
  };
  return (
    <div className="denounce-image-gallery">
      <div className="denounce-image-gallery-wrapper">
        {images && images.length ? (
          images.map((image, i) => (
            <React.Fragment key={`thumbnail_fragment_figures_modal_${i}`}>
              <input
                key={`thumbnail_radio_modal_${i}`}
                type="radio"
                id={`thumbnail-radio-modal-${i}`}
                name="thumbnail-radio-modal"
                defaultChecked={i === currentImageIndex}
              />
              <figure key={`thumbnail_figure_modal_${i}`} className="image-container">
                <div className="image-trigger">
                  <img alt={image.alt} src={image.src} />
                </div>
              </figure>
            </React.Fragment>
          ))
        ) : (
          <>
            <input type="radio" name="thumbnail-radio" defaultChecked={true} />
            <figure className="image-container">
              <div className="image-trigger">
                <img alt={fallbackImage.alt} src={fallbackImage.src} />
              </div>
            </figure>
          </>
        )}

        <div className="denounce-image-gallery-labels">
          <div className="arrowLeft" onPointerDown={() => startScrolling("left")} onPointerUp={stopScrolling} onPointerLeave={stopScrolling}>
            {showLeftArrow && <img src="/images/catalog/Chevron24Left.svg" alt="Left Arrow" />}
          </div>

          <div className="gallery-wrapper" ref={galleryRef}>
            {images &&
              images.length &&
              images.map((image, i) => (
                <React.Fragment key={`thumbnail_fragment_modal_${i}`}>
                  <label
                    key={`thumbnail_modal_${i}`}
                    htmlFor={`thumbnail-radio-modal-${i}`}
                    className={classnames("label_thumbnail", { selected: i === currentImageIndex })}
                  >
                    {/* Checkbox en la esquina superior izquierda */}
                    <input
                      type="checkbox"
                      className="image-checkbox"
                      id={`checkbox-${i}`}
                      checked={photoDenounced.has(image.alt)}
                      onChange={() => handleCheckboxChange(i)}
                    />
                    <img
                      width="70"
                      height="70"
                      key={`image_modal_${i}`}
                      alt={image.alt}
                      src={image.thumbnail}
                      onMouseOver={(e) => {
                        e.target.click();
                      }}
                      onClick={() => {
                        setCurrentImageIndex(i);
                      }}
                    />
                  </label>
                </React.Fragment>
              ))}
          </div>

          <div className="arrowRight" onPointerDown={() => startScrolling("right")} onPointerUp={stopScrolling} onPointerLeave={stopScrolling}>
            {showRightArrow && <img src="/images/catalog/Chevron24Right.svg" alt="Right Arrow" />}
          </div>
        </div>
      </div>

      <div className="variants-suspect-btn-ctn">
        <div className="variants-suspect-btn">
          <div
            className={`suspect-btn ${photoDenounced.size > 0 ? "selected" : ""}`}
            onClick={photoDenounced.size > 0 ? () => openVariantsReportModal(Array.from(photoDenounced)) : null}
          >
            {photoDenounced.size === 1 ? t("report_label") : t("report_label_plural")}
          </div>
        </div>
      </div>
    </div>
  );
}

const actions = {
  openModal,
};
export default connect(null, actions)(DenounceImageGalleryModal);
